/** @format */

import React, { useEffect, useState } from "react";
import {
  Accordion,
  ActionIcon,
  Badge,
  Modal,
  Table,
  Text,
} from "@mantine/core";
import { Eye, History, Plus } from "tabler-icons-react";
import { getRelatedAgreement } from "../../utilities/apis/agreements";
import { formatDate } from "../../utilities/utilities";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import { getStatusColor, getStatusText } from "../../utilities/enums";
import AgreementAuditLogModal from "./AgreementAuditLogModal";

const RelatedAgreementModal = ({ agreementId }) => {
  const [relatedAgreementData, setRelatedAgreementData] = useState({
    parent: null,
    children: null,
    loading: true,
    count: 0,
  });
  const [dontShowId, setDontShowId] = useState("");
  const [showModalRelated, setShowModalRelated] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [relatedId, setRelatedId] = useState(null);
  const [showAuditId, setShowAuditId] = useState(null);

  const onViewClick = (agreementviewId) => {
    // const url =
    //   process.env.PUBLIC_URL +
    Navigate(`/app/agreements_manager/agreements/details/${agreementviewId}`);
    // window.open(url, "noopener,noreferrer");
  };
  useEffect(() => {
    const fetchRelatedAgreement = async () => {
      try {
        const response = await apiWrapWithErrorWithData(
          getRelatedAgreement({ agreementId }),
        );

        if (response.success) {
          setRelatedAgreementData({
            loading: false,
            parent: response.parent,
            children: response.children,
          });
        }
      } catch (error) {
        console.error("Error fetching audit log:", error);
      }
    };

    fetchRelatedAgreement();
  }, [agreementId]);

  return (
    <>
      <div className="flex flex-col">
        <div className="flex justify-between my-4">
          <Text>{`related agreement/s for agreement-${agreementId}`}</Text>
        </div>
      </div>

      <br />

      {!relatedAgreementData?.loading && (
        <div
          className="flex flex-col"
          style={{
            overflowX: "scroll",
            marginTop: "15px",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          <Accordion variant="contained">
            <div className="mb-2">
              {relatedAgreementData.parent?.id ? (
                <Accordion.Item value="parent">
                  <Accordion.Control>Parent Agreement</Accordion.Control>
                  <Accordion.Panel>
                    <Table striped>
                      <thead>
                        <tr>
                          <th>ain</th>
                          <th>type</th>
                          <th>business unit</th>
                          <th>status</th>
                          <th>second party</th>
                          <th>contract date</th>
                          <th colSpan={3}>&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr key={relatedAgreementData.parent.id}>
                          <td>{`agreement-${relatedAgreementData.parent.id}`}</td>
                          <td>{relatedAgreementData.parent.typeOfAgreement}</td>
                          <td>{relatedAgreementData.parent.mapBusinessunit}</td>
                          <td>
                            <Badge
                              color={getStatusColor(
                                relatedAgreementData.parent.status,
                              )}
                            >
                              {getStatusText(
                                relatedAgreementData.parent.status,
                              )}
                            </Badge>
                          </td>
                          <td>
                            {relatedAgreementData.parent.secondParty?.name ||
                              "-"}
                          </td>
                          <td>
                            {formatDate(
                              relatedAgreementData.parent.dateOfContract,
                            )}
                          </td>
                          <td>
                            <ActionIcon
                              onClick={() =>
                                onViewClick(relatedAgreementData.parent.id)
                              }
                              color="white"
                            >
                              <Eye size={24} />
                            </ActionIcon>
                          </td>
                          <td>
                            <ActionIcon
                              onClick={() => {
                                setRelatedId(relatedAgreementData.parent.id);
                                setShowModalRelated(true);
                              }}
                              color="white"
                            >
                              <Plus size={24} />
                            </ActionIcon>
                          </td>
                          <td>
                            <ActionIcon
                              onClick={() => {
                                setShowAuditId(relatedAgreementData.parent.id);
                                setShowModal(true);
                              }}
                              color="white"
                            >
                              <History size={24} />
                            </ActionIcon>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </Accordion.Panel>
                </Accordion.Item>
              ) : (
                <Text>agreement-{agreementId} is a parent agreement</Text>
              )}
            </div>
            <div>
              {relatedAgreementData.children.length > 0 ? (
                <Accordion.Item value="children">
                  <Accordion.Control>Child Agreement(s)</Accordion.Control>
                  <Accordion.Panel>
                    <Table striped>
                      <thead>
                        <tr>
                          <th>ain</th>
                          <th>type</th>
                          <th>business unit</th>
                          <th>status</th>
                          <th>second party</th>
                          <th>contract date</th>
                          <th colSpan={3}>&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                        {relatedAgreementData.children.map((row) => (
                          <tr key={row.id}>
                            <td>{`agreement-${row.id}`}</td>
                            <td>{row.typeOfAgreement}</td>
                            <td>{row.mapBusinessunit}</td>
                            <td>
                              <Badge color={getStatusColor(row.status)}>
                                {getStatusText(row.status)}
                              </Badge>
                            </td>
                            <td>{row.secondParty?.name || "-"}</td>
                            <td>{formatDate(row.dateOfContract)}</td>
                            <td>
                              <ActionIcon
                                onClick={() => onViewClick(row.id)}
                                color="white"
                              >
                                <Eye size={24} />
                              </ActionIcon>
                            </td>
                            <td>
                              <ActionIcon
                                onClick={() => {
                                  setRelatedId(row.id);
                                  setShowModalRelated(true);
                                }}
                                color="white"
                              >
                                <Plus size={24} />
                              </ActionIcon>
                            </td>
                            <td>
                              <ActionIcon
                                onClick={() => {
                                  setShowAuditId(row.id);
                                  setShowModal(true);
                                }}
                                color="white"
                              >
                                <History size={24} />
                              </ActionIcon>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Accordion.Panel>
                </Accordion.Item>
              ) : (
                <Text>
                  agreement-{agreementId} does not has child agreement agreement
                </Text>
              )}
            </div>
          </Accordion>
        </div>
      )}

      {showModalRelated && (
        <Modal
          overflow="inside"
          opened
          onClose={() => setShowModalRelated(false)} // Call the handler on modal close
          size="calc(80vw)"
        >
          <RelatedAgreementModal agreementId={relatedId} />
        </Modal>
      )}
      {showModal && (
        <Modal
          overflow="inside"
          opened
          onClose={() => setShowModal(false)} // Call the handler on modal close
          size="calc(80vw)"
        >
          <AgreementAuditLogModal agreementId={showAuditId} />
        </Modal>
      )}
    </>
  );
};

export default RelatedAgreementModal;
